import BaseSimulatorController from './base_simulator_controller'
import { formatCurrency } from '../utils/currency'

export default class LendingSimulatorController extends BaseSimulatorController {
  static values = {
    totalRate: Number
  }

  static targets = [
    'input',
    'investedAmount',
    'estimatedReturn',
    'estimatedTotal',
    'finalCapital'
  ]

  refresh(value) {
    if (!value || !this.totalRateValue) return

    const estimatedTotal = value * this.totalRateValue
    const capitalFinal = value + estimatedTotal

    this.investedAmountTarget.textContent = formatCurrency(value)
    this.estimatedReturnTarget.textContent = formatCurrency(estimatedTotal, { signed: true })
    this.estimatedTotalTarget.textContent = formatCurrency(estimatedTotal, { signed: true })
    this.finalCapitalTarget.textContent = formatCurrency(capitalFinal)
  }
}
